import * as React from 'react';

import Localize from 'app/src/localize/Localize';
import { createReactRenderer } from 'helpers/react-renderer';

import DiscountRuleDropdown from '../DiscountRuleDropdown';

interface Props {
  className?: string;
  initialValue?: string | number;
  isDirtyOnChange?: boolean;
  isDisabled?: boolean;
  name: string;
}

enum DISCOUNT_CALC_TYPE {
  PERCENTAGE = 'percentage',
  FIXED = 'fixed',
}

interface Translations {
  percentage: string;
  fixed: string;
}

const DiscountRuleDiscountType: React.FC<Props> = ({
  className = '',
  initialValue,
  isDirtyOnChange,
  isDisabled,
  name,
}) => {
  const currencySymbol = Localize.getCurrencySymbol();

  const [translations, setTranslations] = React.useState<Translations>({
    percentage: 'Percentage (%)',
    fixed: `Fixed amount off (${currencySymbol})`,
  });

  const options = [
    { value: DISCOUNT_CALC_TYPE.PERCENTAGE, label: translations.percentage },
    {
      value: DISCOUNT_CALC_TYPE.FIXED,
      label: translations.fixed,
    },
  ];

  const initialOption =
    (initialValue && options.find(option => option.value === initialValue)) || options[0];

  React.useEffect(() => {
    window.Localize?.translate(translations.percentage, null, returnedTranslation => {
      setTranslations(prevState => ({
        ...prevState,
        percentage: returnedTranslation.toString(),
      }));
    });

    // Currency symbol can change position depending on the language.
    // Note it wraps `currencySymbol` in () as a variable.
    window.Localize?.translate(
      `Fixed amount off %{currencySymbol}`,
      { currencySymbol: `(${currencySymbol})` },
      returnedTranslation => {
        setTranslations(prevState => ({
          ...prevState,
          fixed: returnedTranslation.toString(),
        }));
      }
    );
  });

  return (
    <DiscountRuleDropdown
      className={className}
      initialOptions={[initialOption]}
      isDirtyOnChange={isDirtyOnChange}
      isDisabled={isDisabled}
      isSearchable={false}
      name={name}
      options={options}
      placeholder="Select the discount type"
    />
  );
};

const RenderedComponent = createReactRenderer({
  component: DiscountRuleDiscountType,
  selector: '[data-react-root="DiscountRuleDiscountType"]',
});

window.history.onChangeState(
  {
    id: undefined,
    name: 'discount_rule.views.discount_rule',
  },
  () => {
    RenderedComponent.mount();
  },
  () => {
    RenderedComponent.unmount();
  }
);

export default DiscountRuleDiscountType;
